import { OrganisationMin, LiteralUnion } from 'models';

import { API_URL } from 'config';
import { makeAPICall } from './api';

export declare namespace API {
    export interface GroundStation {
        id: number;
        organisation: OrganisationMin;
        name: string;
        description: string;
        address: string;
        lon: number;
        lat: number;
        altitude: number;
        enabled: boolean;
        created: string;
        czml: string;
        application: number;
        supported_commands: number[];
        connection_id: string | null;
    }

    export interface GroundStationCommandResponse {
        success: boolean;
        command: Command;
        response?: any;
        error?: string;
    }

    export interface CommandType {
        id: number;
        name: string;
        summary: string;
        help: string;
        parameters: string[];
        expect_results: boolean;
        result_parameters: string[];
        created: string;
    }

    export interface Command {
        id: number;
        groundstation: number;
        user: number;
        type: { id: number; name: string };
        status: LiteralUnion<'SENT' | 'FINISHED'>;
        error: string | null;
        parameters: Record<string, string | number | boolean> | null;
        results: Record<string, string | number | boolean> | null;
        last_updated: string;
        created: string;
    }
}

export interface CommandType {
    id: number;
    name: string;
    summary: string;
    help: string;
    parameters: string[];
    expectResults: boolean;
    resultParameters: string[];
    created: Date;
}

export interface GroundStation {
    id: number;
    organisation: OrganisationMin;
    name: string;
    description: string;
    address: string;
    lon: number;
    lat: number;
    altitude: number;
    enabled: boolean;
    created: Date;
    czml: string;
    application: number;
    supportedCommands: number[];
    connectionId: string | null;
}

export interface GroundStationCommand {
    id: number;
    command: string;
    params?: Record<string, string | number | boolean> | null;
}

const GROUNDSATIONS_ROUTE = '/groundstations';
const GROUNDSTATION_COMMANDTYPES_ROUTE = '/groundstations-command-type';

export const mapAPIToGroundStationCommandType = ({
    created,
    expect_results,
    result_parameters,
    ...rest
}: API.CommandType): CommandType => ({
    ...rest,
    created: new Date(created),
    expectResults: expect_results,
    resultParameters: result_parameters,
});

export const listGroundStationCommandTypes = makeAPICall<
    CommandType[],
    void,
    { results: API.CommandType[] }
>(
    () => ({
        url: `${API_URL}${GROUNDSTATION_COMMANDTYPES_ROUTE}/`,
    }),
    (data) => data.results.map(mapAPIToGroundStationCommandType),
);

export const mapAPIToGroundStation = ({
    created,
    supported_commands,
    connection_id,
    ...rest
}: API.GroundStation): GroundStation => ({
    ...rest,
    created: new Date(created),
    supportedCommands: supported_commands,
    connectionId: connection_id,
});

export const listGroundStations = makeAPICall<
    GroundStation[],
    void,
    { results: API.GroundStation[] }
>(
    () => ({
        url: `${API_URL}${GROUNDSATIONS_ROUTE}/`,
    }),
    (data) => data.results.map(mapAPIToGroundStation),
);

export const getGroundStationCZML = makeAPICall<any, { id: string }, any>(
    ({ id }) => ({
        url: `${API_URL}${GROUNDSATIONS_ROUTE}/${id}/czml.json`,
    }),
    (data) => data,
);

export const sendCommand = makeAPICall<
    API.GroundStationCommandResponse,
    GroundStationCommand,
    API.GroundStationCommandResponse
>(
    ({ id, command, params }) => ({
        url: `${API_URL}${GROUNDSATIONS_ROUTE}/${id}/send_command/`,
        requestData: {
            method: 'POST',
            body: JSON.stringify({
                command,
                parameters: params ?? {},
            }),
        },
    }),
    (results) => results,
);
